import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { EconomicalCapsulesComponent } from './components/versions/economical-capsules/economical-capsules.component';
// import { StudiesComponent } from './components/versions/studies/studies.component';
// import { VersionsComponent } from './components/versions/versions.component';
import { HomeComponent } from './components/home/home.component';
import { EventsModule } from './components/events/events.module';
import { ArchiveComponent } from './components/home/archive/archive.component';
import { ContactsComponent } from './components/about/contacts/contacts.component';
import { WelcomeMessageComponent } from './components/versions/welcome-message/welcome-message.component';
// import { EventsComponent } from './components/events/events.component';
// import { ExhibitionsComponent } from './components/events/exhibitions/exhibitions.component';
// import { SeminarsComponent } from './components/events/seminars/seminars.component';
// import { LecturesComponent } from './components/events/lectures/lectures.component';
// import { EconomyIndexComponent } from './components/versions/economy-index/economy-index.component';
// import { AboutComponent } from './components/about/about.component';
// import { CountryFilesComponent } from './components/versions/country-files/country-files.component';
// import { EstablishmentComponent } from './components/about/establishment/establishment.component';
// import { VisionComponent } from './components/about/vision/vision.component';
// import { StandardsComponent } from './components/about/standards/standards.component';
// import { TeamWorkComponent } from './components/about/team-work/team-work.component';
// import { ExhibitionDetailsComponent } from './components/events/exhibitions/exhibition-details/exhibition-details.component';



const routes: Routes = 
[
   { path: '', component: HomeComponent,data: { breadcrumb:  'الرئيسية' } }, 
   { path: 'archive', component: ArchiveComponent,data: { breadcrumb:  'ارشيف الاخبار الاقتصادية' } }, 
   { path: 'contactUs', component: ContactsComponent,data: { breadcrumb:  '  تواصل معنا' } }, 
   { path: 'welcomMessage', component: WelcomeMessageComponent,}, 



 
  { path: 'events', loadChildren: () => import('./components/events/events.module').then((m) => m.EventsModule) },

  { path: 'about', loadChildren: () => import('./components/about/about.module').then((m) => m.AboutModule) },
  { path: 'versions', loadChildren: () => import('./components/versions/versions.module').then((m) => m.VersionsModule) },

   

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
